<template>
  <ViewContainer :title="$t('menu.admin.activity_logs')">
    <LogsTable
      :columnsEnabled="columnsEnabled"
      :filtersEnabled="filtersEnabled"
      @updateTable="getLogs"
    />
  </ViewContainer>
</template>

<script>
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import LogsTable from './LogsTable.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    LogsTable,
    ViewContainer,
  },

  data() {
    return {
      modalStatus: false,
      columnsEnabled: [
        'eventName',
        'eventSource',
        'eventTime',
        'sourceType',
        'sourceAccountId',
        'sourceAccountName',
        'sourceOrganizationId',
        'sourceAccountIP',
        'systemIP',
        'systemRegion',
        'action',
        'eventDescription',
        'userAgent',
        'userAgentVersion',
        'responseType',
        'responseCode',
        'targetAccountId',
        'targetType',
        'targetId',
        'admin__targetOrganizationId',
        'loggedAt',
        'context',
      ],
      filtersEnabled: [
        'eventName',
        'eventSource',
        'sourceType',
        'sourceAccountId',
        'sourceOrganizationId',
        'targetAccountId',
        'targetType',
        'targetId',
        'targetOrganizationId',
        'responseType',
        'responseCode',
      ],
    }
  },
  created() {
    this.getLogs()
  },

  methods: {
    ...mapActions(['getAllAuditLogs']),
    getLogs() {
      return this.getAllAuditLogs()
    },
  },
}
</script>
